"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseQueryString = parseQueryString;

var _querystringify = _interopRequireDefault(require("querystringify"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function parseQueryString(queryString) {
  var queryStringParams = _querystringify.default.parse(queryString);

  for (var key in queryStringParams) {
    if (queryStringParams[key] === 'null') {
      queryStringParams[key] = null;
    } else if (queryStringParams[key] === 'undefined') {
      queryStringParams[key] = undefined;
    }
  }

  return queryStringParams;
}